/* istanbul ignore file */
// Generated code for Big.Webservice.Controllers.RegisterController.
// Edit _ApiService.tst to change the generated output.
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ZorroApiClient } from '../zorro-api-client';

import { RegisterRequest } from '../models/register-request';
import { RequiredDocumentModel } from '../models/required-document-model';
import { RequiredDocumentsResponse } from '../models/required-documents-response';

@Injectable()
export class RegisterApiService extends ZorroApiClient {

    constructor(
      private readonly httpClient: HttpClient
    ) {
        super();
    }

    public getRequiredDocumentsByCaseNr(caseNr: number, spinnerMessage: string = null): Observable<RequiredDocumentsResponse> {
        return this.httpClient.get<RequiredDocumentsResponse>(`/api/register/requireddocs/${caseNr}`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }


    public register(request: RegisterRequest, spinnerMessage: string = null): Observable<string> {
        return this.httpClient.post<string>(`/api/register`, request,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public getRequiredDocuments(request: RegisterRequest, spinnerMessage: string = null): Observable<RequiredDocumentModel[]> {
        return this.httpClient.post<RequiredDocumentModel[]>(`/api/register/requireddocs`, request,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

}
